<script>
import { Line } from "vue-chartjs";

export default {
  props: {
    dateRange: {
      type: Array,
      default() {
        return [];
      }
    },
    dataSets: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  extends: Line,
  mounted() {
    // console.log("this.datasets", this.dataSets);
    // Overwriting base render method with actual data.
    this.renderChart({
      labels: this.dateRange,
      datasets: this.dataSets
    });
  }
};
</script>

<style scoped></style>
